import $ from 'jquery';
import '../components/menu';
import '../components/words/intro';
import '../components/sliders/slider-2';
import '../components/cards/card-2';
import '../components/lists/list-3';
import '../../sass/amenities.scss';

$(document).ready(function () {});
